import React, { FC } from 'react';
import { Grid, GridItem } from '@modernhealth/vital-components';

import Topic from 'src/modules/topics/components/Topic';
import { mapContentLinkToTileProps } from 'src/modules/dashboard/helpers/contentLinkNodeToTile';
import { ContentCardProps } from 'src/modules/dashboard/components/ContentCard';

export const TileContentCard: FC<ContentCardProps> = ({ links }) => {
    const mappedLinks = links.map(mapContentLinkToTileProps);

    return (
        <Grid lgMode="3columns">
            {mappedLinks.map((topic, i) => {
                if (!topic) return null;
                if (!topic?.onClick) return null;

                return (
                    <GridItem key={topic?.id} lg={1} md={2}>
                        <Topic
                            title={topic.title}
                            image={topic.image}
                            colorScheme={topic.colorScheme}
                            testId={`TopicItem-${i}`}
                            onClick={topic.onClick}
                        />
                    </GridItem>
                );
            })}
        </Grid>
    );
};
